
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.001 16c-2.206 0-4-1.794-4-4s1.794-4 4-4 4 1.794 4 4-1.795 4-4 4zm0-7c-1.654 0-3 1.346-3 3s1.346 3 3 3 3-1.346 3-3-1.346-3-3-3z"}}),_c('path',{attrs:{"d":"M12.001 19C6.281 19 1.56 14.146.25 12.658a1.006 1.006 0 01-.002-1.315C1.559 9.855 6.281 5 12.001 5c5.714 0 10.432 4.845 11.747 6.337l.006.007c.325.374.325.938 0 1.312C22.442 14.145 17.72 19 12.001 19zm0-13C6.701 6 2.24 10.594 1 12.003 2.241 13.406 6.7 18 12.001 18c5.3 0 9.76-4.594 11.001-6.003C21.76 10.594 17.3 6 12.001 6z"}})])
          )
        }
      }
    